<onyx-modal
  variant="center"
  [heading]="`${I18N}.${data.mode}Heading`"
  [size]="640"
  [showClose]="!loading()"
  [resize]="data.variant !== 'table'"
  [close$]="close$"
  (closeModal)="dialogRef.close($event ?? undefined)"
>
  <form [formGroup]="form">
    <div class="container">
      <onyx-dropdown
        [formControl]="form.controls.icon"
        [label]="`${I18N}.icon`"
        [templateRef]="emojiPickerTemplate"
        [showValueIcon]="true"
      ></onyx-dropdown>

      <onyx-text-field
        [formControl]="form.controls.name"
        [label]="`${I18N}.name`"
      ></onyx-text-field>
    </div>

    @if (data.variant === 'table') {
      <onyx-table-columns-picker
        [columns]="data.columns"
        [(value)]="value"
        [defaultView]="data.defaultView"
        variant="modal"
      ></onyx-table-columns-picker>
    }
  </form>

  <ng-container bottomLeftOptions>
    @if (data.mode === OnyxFormMode.EDIT) {
      <onyx-button
        variant="outlined"
        color="red"
        [disabled]="!!loading()"
        [spinner]="loading() === 'delete'"
        (click)="loading() ? null : delete()"
      >
        {{ `${I18N}.delete` | translate }}
      </onyx-button>
    }
  </ng-container>

  <ng-container bottomRightOptions>
    <onyx-button
      variant="outlined"
      [disabled]="!!loading()"
      (click)="loading() ? null : cancel()"
    >
      {{ `${I18N_COMMON}.cancel` | translate }}
    </onyx-button>

    <onyx-button
      [disabled]="!!loading()"
      [spinner]="loading() === 'submit'"
      (click)="loading() ? null : submit()"
    >
      {{ `${I18N}.${data.mode}` | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>

<ng-template #emojiPickerTemplate>
  <onyx-icon-picker
    [value]="form.controls.icon.getRawValue()"
    (valueChange)="form.controls.icon.setValue($event)"
  ></onyx-icon-picker>
</ng-template>
